import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { ALL_ORDER_ARCHIVES_VIEW_BY_PAGE_QUERY } from "../../../graphql/OrderArchives/OrderArchives.graphql";
import OrderArchiveFilters from "./OrderArchiveFilters";
import DataTable from "../../../components/DataTable";
import { ORDER_VIEW_COLUMNS } from "../Orders/columns";
import PageHeader from "../../../components/PageHeader";
import { getFilterState, saveFilterState } from "../../../utils";

const OrderArchivesPage = () => {
  const INITIAL_FILTER_STATE = getFilterState("ORDER_ARCHIVE_FILTERS");
  const [filters, setFilters] = useState(INITIAL_FILTER_STATE);
  const history = useHistory();
  const handleSetFilters = inputs => {
    Object.keys(inputs).forEach(
      key =>
        typeof inputs[key] !== "boolean" &&
        (!inputs[key] ||
          inputs[key] === 0 ||
          inputs[key] === "" ||
          inputs[key].length === 0) &&
        delete inputs[key]
    );
    // Seting up the Filters values
    const Filters = {};
    Object.keys(inputs).forEach(
      key =>
        (Filters[key] =
          inputs[key] && inputs[key].value ? inputs[key].value : inputs[key])
    );
    setFilters({
      ...Filters,
      Status: inputs.Status
    });
    saveFilterState("ORDER_ARCHIVE_FILTERS", Filters);
  };
  const resetFilters = () => handleSetFilters({ Status: true });

  return (
    <React.Fragment>
      <PageHeader
        FilterComponent={OrderArchiveFilters}
        columns={ORDER_VIEW_COLUMNS}
        filters={filters}
        name="VW_OrderArchivesByPage"
        query={ALL_ORDER_ARCHIVES_VIEW_BY_PAGE_QUERY}
        resetFilters={resetFilters}
        setFilters={handleSetFilters}
        title="Archived Orders"
      />
      <DataTable
        isPaginated
        columns={ORDER_VIEW_COLUMNS}
        dataQuery={ALL_ORDER_ARCHIVES_VIEW_BY_PAGE_QUERY}
        hiddenColumns={["StatusIdListOrder"]}
        initialSortBy={[
          { id: "StatusIdListOrder", desc: false },
          {
            id: "PickupDate",
            desc: false
          },
          { id: "OrderNumber", desc: false }
        ]}
        name="VW_OrderArchivesByPage"
        where={filters}
        onRowClick={({ RecId }) =>
          history.push(`/dispatch/order-archive/${RecId}/summary`)
        }
      />
    </React.Fragment>
  );
};
OrderArchivesPage.propTypes = {};
export default OrderArchivesPage;
